import { Box, BoxProps, Button, Dialog, DialogActions, } from "@mui/material";
import classNames from "classnames";
import { saveAs } from 'file-saver';
import React from 'react';
import styles from "../styles/components/image.module.scss";
import { ModalTitle } from "./modal-title";


type ImgProps = {
    alt: string;
    src: string;
    enableSave?: boolean;
}

export const Img = ({src, className, enableSave, ...props}: BoxProps & ImgProps) => {
  return (
    <Box 
      className={classNames(enableSave ? styles.imageWithSave : null, className)}
      component='img'  
      onClick={() => {
        if (enableSave) {
          const fileName = src.split('/').pop() || 'download.png'
          saveAs(src, fileName)
        }
      }}
      src={src}
      {...props}
    />
  )
};

export const ImageModal = ({alt, src, ...props}: BoxProps & ImgProps) => {
  const [open, setOpen] = React.useState(false)

  const onClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Img className={styles.thumb} alt={alt} src={src} onClick={() => setOpen(true)} />
      <Dialog
        id="image-preview-modal"
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
      >
        <ModalTitle onClose={onClose}>{alt}</ModalTitle>
        <div className={styles.imageContainer}>
          <Img src={src} alt={alt} className={styles.image} enableSave />
        </div>
        <DialogActions sx={{ pb: 3, px: 3 }}>
          <Button
            onClick={onClose}>
              Close
          </Button>
        </DialogActions>
      </Dialog>
  </>
  )
};



                  // onClick={() => {
                  //   saveAs(file, file || 'download.png')
                  // }}